@use '@lib/assets/styles/main.scss' as *;

.root {
  height: 100%;
  min-height: unset;
  border-radius: 10px;
  border: 1px solid $gray200;
}
